// @ts-strict-ignore
import { ArticlePrepareData } from './article-prepare-data';
import { MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';

export class InsertArticlePrepareData extends ArticlePrepareData {

  public acceptingIdentityToInsert: MetaElementUsageIdentityVO;
  public neighborArticleUsageIds: string[];
  public rotationDelta: number;

  public constructor(vectorId: number, givingConnectionNames: string[]) {
    super(vectorId, givingConnectionNames);
  }
}
